import { render, staticRenderFns } from "./MaterialProject.vue?vue&type=template&id=569996f2&scoped=true&"
import script from "./MaterialProject.vue?vue&type=script&lang=js&"
export * from "./MaterialProject.vue?vue&type=script&lang=js&"
import style0 from "./MaterialProject.vue?vue&type=style&index=0&id=569996f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569996f2",
  null
  
)

export default component.exports